

// Sidebar.jsx
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenSquare,
  faBlog,
  faUsers,
  faDashboard,
  faAward,
  faSignOutAlt,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../context/AuthContext";
import CEOIMAGE from "../../assets/images/team2.jpg"

const Sidebar = ({ onClose, isOpen = true, isMobile = false }) => {
  const { logout } = useAuth();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    if (onClose) onClose();
  };

     const menuItems = [
      {
      path: "/admin/dashboard",
      label: "Dashboard",
      icon: <FontAwesomeIcon icon={faDashboard} />,
    },
       {
      path: "/admin/payment",
      label: "Payment",
      icon: <FontAwesomeIcon icon={faBlog} />,
    },
    {
      path: "/admin/query",
      label: "Query",
      icon: <FontAwesomeIcon icon={faAward} />,
    },
    
    {
      path: "/admin/create-team",
      label: "Our Team",
      icon: <FontAwesomeIcon icon={faUsers} />,
    },
    {
      path: "/admin/create-case-study",
      label: "Create Case Study",
      icon: <FontAwesomeIcon icon={faPenSquare} />,
    },
    {
      path: "/admin/create-blog",
      label: "Create Blog",
      icon: <FontAwesomeIcon icon={faBlog} />,
    },
    {
      path: "/admin/create-career",
      label: "Career Page",
      icon: <FontAwesomeIcon icon={faAward} />,
    },
   
  ];

  return (
    <div className={`h-full bg-gradient-to-b from-gray-900 to-gray-800 text-white shadow-2xl flex flex-col transition-all duration-300 ${
      !isMobile && !isOpen ? "w-20" : "w-64"
    }`}>
      {/* Close button for mobile */}
      {isMobile && (
        <div className="md:hidden absolute top-4 right-4 z-10">
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-gray-700 transition-colors"
          >
            <FontAwesomeIcon icon={faTimes} className="w-5 h-5" />
          </button>
        </div>
      )}

      {/* Profile Section - Show only when sidebar is open or on mobile */}
      {(isOpen || isMobile) && !(!isMobile && !isOpen) && (
        <div className="flex flex-col items-center mb-8 mt-8 md:mt-4 px-4">
          <img
            src={CEOIMAGE}
            alt="Profile"
            className="w-24 h-24 object-cover rounded-full border-4 border-blue-500 shadow-lg transition-all duration-300"
          />
          <h3 className="text-lg font-bold text-white mt-3">Parshan Vashisht</h3>
          <p className="text-sm text-gray-300 text-center break-words">info@deetyasoft.com</p>
          <div className="w-12 h-0.5 bg-gradient-to-r from-blue-500 to-purple-500 mt-2"></div>
        </div>
      )}

      {/* Menu */}
      <nav className={`flex-1 ${isOpen ? "px-4" : "px-2"} overflow-y-auto`}>
        <ul className="space-y-2">
          {menuItems.map((item, index) => {
            const isActive = location.pathname === item.path;
            return (
              <li key={index}>
                <Link
                  to={item.path}
                  onClick={onClose}
                  className={`flex items-center rounded-lg transition-all duration-200 group ${
                    isActive
                      ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg"
                      : "text-gray-300 hover:bg-gradient-to-r hover:from-blue-600 hover:to-purple-600 hover:text-white"
                  } ${isOpen ? "space-x-2 px-2 py-2" : "justify-center p-3"}`}
                  title={!isOpen ? item.label : ""}
                >
                  <span className={`${isActive ? "text-white" : "text-gray-400 group-hover:text-white"} transition-colors`}>
                    {item.icon}
                  </span>
                  {isOpen && <span className="text-sm font-medium">{item.label}</span>}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Logout Button */}
      <div className="p-3 border-t border-gray-700 mt-auto">
        <button
          onClick={handleLogout}
          className={`w-full flex items-center rounded-lg text-gray-300 hover:bg-red-600 hover:text-white transition-all duration-200 group ${
            isOpen ? "space-x-2 px-2 py-2" : "justify-center p-3"
          }`}
          title={!isOpen ? "Logout" : ""}
        >
          <FontAwesomeIcon icon={faSignOutAlt} className="text-gray-400 group-hover:text-white" />
          {isOpen && <span className="text-sm font-medium">Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;